export enum DeliveryTypes {
	DELIVERY = 'DELIVERY',
	PICKUP = 'PICKUP',
}
